import React, { ReactNode } from "react";
import { cn } from "@shared/ui/utils/tailwind";

/** Props for the responsive grid container that groups related form fields. */
export interface FormFieldGroupProps {
  children: ReactNode;
  columns?: 1 | 2 | 3;
  className?: string;
  spacing?: "sm" | "md" | "lg";
}

const SPACING_CLASSES: Record<string, string> = {
  sm: "gap-2",
  md: "gap-4",
  lg: "gap-6",
};

const RESPONSIVE_GRID: Record<number, string> = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-3",
};

const FormFieldGroup: React.FC<FormFieldGroupProps> = ({ children, columns = 1, className, spacing = "md" }) => {
  return (
    <div className={cn("grid", SPACING_CLASSES[spacing], RESPONSIVE_GRID[columns], className)}>
      {children}
    </div>
  );
};

export default FormFieldGroup;
